import { useContext } from 'react';
import { AccountContext } from '../../AccountContext';
import { useGetPersistentDebtForAccount } from '@app/sdk';
import { Table, TableBody, TableCell, TableRow } from 'semantic-ui-react';

export default function PersistentDebt() {
  const { accountId } = useContext(AccountContext);
  const { data: persistentDebt } = useGetPersistentDebtForAccount(accountId);

  return (
    <div>
      <Table definition collapsing>
        <TableBody>
          <TableRow>
            <TableCell>Latest Billing Period</TableCell>
            <TableCell>{persistentDebt?.assessedAtBillingPeriodId} </TableCell>
          </TableRow>
          <TableRow>
            <TableCell>Balance Amount</TableCell>
            <TableCell> {persistentDebt?.balanceAmount.value}</TableCell>
          </TableRow>
          <TableRow>
            <TableCell>Balance Assessment Outcome</TableCell>
            <TableCell>{persistentDebt?.balanceAssessmentOutcome}</TableCell>
          </TableRow>
          <TableRow>
            <TableCell> Threshold Date</TableCell>
            <TableCell>{persistentDebt?.thresholdDate}</TableCell>
          </TableRow>
        </TableBody>
      </Table>
      <Table celled>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell>Persistent Debt Index</Table.HeaderCell>
            <Table.HeaderCell>Ratio</Table.HeaderCell>
            <Table.HeaderCell>Cure Amount</Table.HeaderCell>
            <Table.HeaderCell>Indicator</Table.HeaderCell>
          </Table.Row>
        </Table.Header>

        <Table.Body>
          {persistentDebt?.assessmentDetails?.map((item, index) => (
            <Table.Row key={index}>
              <Table.Cell>{item?.persistentDebtIndex}</Table.Cell>
              <Table.Cell>{item?.ratio}</Table.Cell>
              <Table.Cell>{item?.cureAmount.value}</Table.Cell>
              <Table.Cell>{item?.indicator.toString()}</Table.Cell>
            </Table.Row>
          ))}
        </Table.Body>
      </Table>
    </div>
  );
}
